module.exports = __webpack_public_path__ + "static/media/option-strength.db84a171.jpg";